export const ERA5 = {
  title: {
    value: 'ERA5',
  },
  paragraph: {
    value: `The data set ECMWF Reanalysis v5 (ERA5) includes a selection of global-scale meteorological
    data variables. ERA5 is produced by the European Center for Medium-Range Weather Forecasts
    (ECMWF) and is a fully coupled model representing the interaction between the Earth's
    oceans, land and atmosphere. The data set is developed for and distributed under the
    Copernicus Climate Change Service (C3S).`,
  },
  table: {
    value: {
      header: ['General', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          General: 'Title',
          Model: 'ECMWF Reanalysis v5 (ERA5)',
        },
        {
          General: 'Geographical Coverage',
          Model: 'Global',
        },
        {
          General: 'Category',
          Model: 'Meteorological Parameters',
        },
        {
          General: 'Source Name',
          Model: 'ECMWF Reanalysis v5 (ERA5), Selected Hourly Timeseries Products',
        },
        {
          General: 'Publisher',
          Model: 'European Center for Medium-Range Weather Forecasts (ECMWF) ',
        },
        {
          General: 'Product type',
          Model: 'Grid',
        },
        {
          General: 'Cost (ex. VAT)',
          Model: 'Free',
        },
        {
          General: 'Typical Applications',
          Model: 'Wind, Wave, Hydrodynamic, Offshore and Marine projects',
        },
        {
          General: 'References',
          Model: `ECWMF ERA5 documentation: ***https://confluence.ecmwf.int/display/CKB/ERA5%3A+data+documentation#heading-TheIFSanddataassimilation***
          ERA5 dataset description: ***https://cds.climate.copernicus.eu/cdsapp#!/dataset/reanalysis-era5-single-levels?tab=overview***
          `,
        },
      ],
    },
  },
  table1: {
    value: {
      header: ['Coverage', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Coverage: 'Geographical Range',
          Model: 'Global Longitude: -180°W to 180°E, Latitude: -90°S to 90°N',
        },
        {
          Coverage: 'Geographical Resolution',
          Model: `Data variables resolutions (quadratic grid cells): 0.25 degree `,
        },
        {
          Coverage: 'Vertical Reference',
          Model: 'Sea Surface',
        },
        {
          Coverage: 'Temporal Reference',
          Model: 'UTC',
        },
        {
          Coverage: 'Temporal Range',
          Model:
            'Data Link coverage: 1/1-1979 -> Present (change to end date if daily updates to present not yet supported)',
        },
        {
          Coverage: 'Temporal Resolution',
          Model: '1 hour',
        },
      ],
    },
  },
  table2: {
    value: {
      header: ['Variables', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Variables: 'Name (Unit)',
          Model: `Wind velocity components (U & V) at 10m [m/s] `,
        },
        {
          Variables: 'Name (Unit)',
          Model: `Air Pressure at Mean Sea Level [hPa] `,
        },
      ],
    },
  },
  table3: {
    value: {
      header: ['Credits', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Credits: 'Cited Authors and Originators',
          Model: `European Center for Medium-Range Weather Forecasts (ECMWF), Reading, United Kingdom, ECMWF, Shinfield Park, RG2 9AX`,
        },
        {
          Credits: 'License',
          Model: `***https://confluence.ecmwf.int/display/CKB/ERA5%3A+data+documentation#heading-TheIFSanddataassimilation***`,
        },
      ],
    },
  },
};
